import React, {useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import { useMutation } from "react-query";
import apiClient from "../../http-common";
import { useNavigate } from "react-router-dom";
import {
  triggerSuccess,
  triggerError,
  setErrorMessage,
  setSuccessMessage,
} from '../Request/StatusFormatter';

const Forgot = () => {
    const initialLogin = {
        email: '',
    }
    const [loginForm, setLoginForm] = useState(initialLogin);
    const onChange = (e) =>
    setLoginForm({ ...loginForm, [e.target.name]: e.target.value });

    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(
        async () => {
          return await apiClient.post(`/api/forgot-password`, {
            email: loginForm.email,
          });
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess();
            setTimeout(() => {
                window.location.href = '/update-password';
            }, 5000);
            
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);  
            triggerError();
          },
        }
      );
      const onSubmit = async() =>{
        postLogin();
        // await apiClient.get("/sanctum/csrf-cookie").then(() => {
         
        // })
      }   

    useEffect(() => {
        document.title = 'FORGOT PASSWORD';
      });
  return (
    <div className="page-content my-0 py-0">
        <div className="card bg-5 card-fixed">
            <div className="card-center mx-3 px-4 py-4 rounded-m" style={{backgroundColor: '#4b3609'}}>
                <div className="text-center d-flex justify-content-center mb-4">
                <img src="/images/logo/logo-dark.png" height="60" alt="logo" className="logo-image"/>
                </div>
                <h1 className="font-30 font-800 mb-0 text-center text-dark">Recover Account</h1>
                <p className="text-center">Recover your Account</p>
                <div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
                    <i translate="no" className="bi bi-at font-16"></i>
                    <input translate="no" type="email" onChange={onChange} name='email' className="form-control text-dark rounded-xs" id="c1" placeholder="Email Address"/>
                    <label htmlFor="c1" className="text-dark">Email Address</label>
                    <span>(required)</span>
                </div>

                <div onClick={onSubmit} className="btn btn-full gradient-green shadow-bg shadow-bg-s mt-4">
                  {isSendingRequest? <span>sending...</span>: <span>Send Recovery Instructions</span>}
                </div>
                
                <div className="row">
                    <div className="col-6 text-start">
                        <Link to="/register" className="font-14 color-green-light pt-4 d-block">Create Account</Link>
                    </div>
                    <div className="col-6 text-end">
                        <Link to="/login" className="font-14 color-green-light pt-4 d-block">Sign In Account</Link>
                    </div>
                </div>
            </div>
            <div style={{backgroundImage: "url(https://res.cloudinary.com/dzxyvdq14/image/upload/v1659204120/ser-bg.png)"}} className="card-overlay rounded-0 m-0 opacity-90 gradient-green">
            </div>
        </div>
    </div>
  )
}

export default Forgot